import { createFileRoute } from "@tanstack/react-router";
import AdminAvatarsPage from "@/admin/pages/avatars";

export const Route = createFileRoute("/admin/avatars")({
  component: AdminAvatarsPage,
});
